import axios from "./axiosInstance"

export type ActivityFeedItem = {
  id: string
  type: "deal" | "company" | "hotlist" | "fmv"
  description: string
  createdAt: string
  actorName: string | null
  actorId: number | null
  dealId: number | null
  dealIdStr: string | null
  companyId: number | null
  companyName: string | null
}

export type ActivityActor = {
  id: number
  name: string
  shortName: string | null
}

export const getActivityFeed = async (params: {
  esoPersonId?: number
  limit?: number
  before?: string
}): Promise<{ items: ActivityFeedItem[]; hasMore: boolean }> => {
  const res = await axios.get("/activity", { params })
  if (!res.data.success) throw new Error("Failed to fetch activity feed")
  return { items: res.data.items, hasMore: res.data.hasMore }
}

export const getActivityActors = async (): Promise<ActivityActor[]> => {
  const res = await axios.get("/activity/actors")
  if (!res.data.success) throw new Error("Failed to fetch activity actors")
  return res.data.actors
}
